module.exports = __webpack_public_path__ + "static/media/helvetica.9003a6ec.woff";